import * as React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import ReCAPTCHA from "react-google-recaptcha";

const NewsletterForm = ({ destination, listId }) => {
  const { locale, formatMessage } = useIntl();
  const [success, setSuccess] = React.useState(null);
  const [error, setError] = React.useState(null);
  const formEl = React.useRef(null);
  const recaptchaEl = React.useRef(null);

  const handleSubmit = (event) => {
    event.preventDefault();
    recaptchaEl.current.execute();
  };

  const handleChange = async () => {
    const formData = new FormData(formEl.current);
    const listId = formData.get("listId");
    const newsletter = formData.get("_optin");
    const email = formData.get("email");
    const destination = formData.get("destination");

    const newsletterResponse = await fetch("/api/newsletter-subscription", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        listId,
        email,
        newsletter,
        destination,
      }),
    });

    if (!newsletterResponse.ok) {
      const data = await newsletterResponse.json();
      setError(data.message);
      recaptchaEl.current.reset();
      return;
    }

    const response = await fetch("https://formspree.io/f/mrgrjgrn", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      const data = await response.json();
      setError(`${data.errors[0].field} ${data.errors[0].message}`);
      recaptchaEl.current.reset();
      return;
    }

    setSuccess(true);
  };

  return (
    <>
      {!success && (
        <form ref={formEl} onSubmit={handleSubmit}>
          <input type="hidden" name="locale" value={locale} />
          <input type="hidden" name="listId" value={listId} />
          <input type="hidden" name="_optin" value="on" />
          {destination && (
            <input type="hidden" name="destination" value={destination.title} />
          )}
          <label>
            <input
              type="email"
              name="email"
              autoComplete="email"
              required
              placeholder={formatMessage({ id: "newsletterLabel" })}
            />
            <span>
              <FormattedMessage id="newsletterLabel" />
            </span>
          </label>
          <button type="submit" className="link">
            <FormattedMessage id="subscribe" />
          </button>
          <ReCAPTCHA
            ref={recaptchaEl}
            size="invisible"
            sitekey="6LcCWWgcAAAAAMX0Bfo5GDtTRuIyaLjDXcVSaBvX"
            onChange={handleChange}
          />
        </form>
      )}
      {success !== null && (
        <p style={{ "margin-top": "1rem" }}>
          <FormattedMessage
            id={success === false ? "error" : "newsletterConfirmation"}
          />
        </p>
      )}
    </>
  );
};

export default NewsletterForm;
